import { render } from "./SpellWordTools.vue?vue&type=template&id=42cabe6e&scoped=true"
import script from "./SpellWordTools.vue?vue&type=script&lang=js"
export * from "./SpellWordTools.vue?vue&type=script&lang=js"

import "./SpellWordTools.vue?vue&type=style&index=0&id=42cabe6e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cabe6e"]])

export default __exports__